import { render, staticRenderFns } from "./PurchaseDeliver.vue?vue&type=template&id=9720ae46&xmlns%3Ath=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml"
import script from "./PurchaseDeliver.vue?vue&type=script&lang=js"
export * from "./PurchaseDeliver.vue?vue&type=script&lang=js"
import style0 from "./PurchaseDeliver.vue?vue&type=style&index=0&id=9720ae46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports